/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Cta_PInputs */

const es_l7_cta_p = /** @type {(inputs: L7_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístralo en unos minutos o llámanos si prefieres hablar antes. Sin contrato hasta que lo tengas claro.`)
};

const gl_l7_cta_p = /** @type {(inputs: L7_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexístrao en uns minutos ou chámanos se prefires falar antes. Sen contrato ata que o teñas claro.`)
};

const en_l7_cta_p = /** @type {(inputs: L7_Cta_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register in minutes or call us if you prefer to talk first. No contract until you are ready.`)
};

/**
* | output |
* | --- |
* | "Register in minutes or call us if you prefer to talk first. No contract until you are ready." |
*
* @param {L7_Cta_PInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_cta_p = /** @type {((inputs?: L7_Cta_PInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Cta_PInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_cta_p(inputs)
	if (locale === "en") return en_l7_cta_p(inputs)
	return es_l7_cta_p(inputs)
});